import MokuTipPanel from './MokuTipPanel'

export default MokuTipPanel